import React from "react";
import { Container, Spinner } from "react-bootstrap";
import useCandidateDashboard from "../useCandidateDashboard";
import { tagStatusColors } from "../../../../_helpers/tagStatusColors";
import { dateDiff, dateFormatter } from "../../../../_helpers/dateFormatter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { faCloudArrowUp, faPlay } from "@fortawesome/free-solid-svg-icons";
export default () => {
  const {
    isLoading,
    assignedAssessmentKits,
    outerClickRef,
    onViewDetailsClick,
    onTakeAssessmentClick,
    getStatusCount,
  } = useCandidateDashboard();
  return (
    <div className="applied-job-board mb-2">
      <div className="hiring-process-dashboard kanban-board-main">
        {isLoading ? (
          <>
            <div className="d-flex align-items-center justify-content-center p-4">
              <Spinner animation="border" variant="primary" />
            </div>
          </>
        ) : (
          Array.isArray(assignedAssessmentKits) &&
          assignedAssessmentKits.map((assesment) => (
            <div className="d-flex flex-column p-3 bg-grey-4 border position-relative h-100 border-radius-10 mb-2">
              <div className="upper">
                <div className="d-flex justify-content-between">
                  <div className="job-info d-flex mb-1">
                    <h3 className="text-dark mb-1 text-capitalize mr-2">
                      {assesment?.assessment_id &&
                        assesment.assessment_id?.title}
                    </h3>
                    <span
                      className={tagStatusColors(assesment?.status)}
                    >
                      {assesment?.status}
                    </span>
                  </div>
                </div>
                <div className="mb-3 mt-1">
                  Skills{" "}
                  <span className="font-weight-medium text-dark bg-grey border rounded-lg py-1 px-2">
                    {assesment?.assessment_id &&
                      assesment.assessment_id?.skills &&
                      assesment.assessment_id.skills.map((item) =>
                        <span>{item?.skill_id && item.skill_id?.skill}</span>
                      )}
                  </span>{" "}
                </div>
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <div className=" fs-smallest">
                    <p className="text-grey-4 mb-0">
                      <span className="border d-inline-block bg-white rounded-lg p-1">
                        Questions{" "}
                        <span className="font-weight-medium  text-dark  bg-grey rounded-lg py-1 px-2">
                          {assesment?.assessment_id &&
                            assesment.assessment_id
                              ?.total_questions}
                        </span>{" "}
                      </span>
                    </p>
                  </div>
                  {assesment?.status ===  "decline" || assesment?.status === "assigned" ||assesment?.status ===  "submitted" ?
                    <FontAwesomeIcon icon={faEye} className="text-dark cursor-pointer"
                      onClick={() => onViewDetailsClick(assesment?.id)}
                    /> : assesment?.status === "accepted" ?
                      <FontAwesomeIcon icon={faPlay} onClick={() => onTakeAssessmentClick(assesment?.id)} className="text-dark cursor-pointer" /> :
                      <FontAwesomeIcon icon={faCloudArrowUp}  onClick={() => onViewDetailsClick(assesment?.id)} className="text-dark cursor-pointer"/>
                  }
                </div>
              </div>
            </div>
          )))}
      </div>
    </div>
  );
};
